import axios from './util/axios.js'

export function getRegisteredExperiments (fullPath = null) {
  const headers = {}
  if (window.__SERVE_PAGE__) {
    headers['SERVE-PAGE'] = window.__SERVE_PAGE__
  }
  return axios.get('/api/experiments/?registered=true', { headers, params: { fullPath } })
}
